import { logger } from '@user/utils/logger'
import { SearchAreaResponse } from '@user/store/map/typings'
import { EntityType } from './types'

export const getRecordCountsByType = (
  result: SearchAreaResponse,
  myRecords: boolean,
): Record<EntityType, number> =>
  myRecords
    ? {
        draftlead: result.myDraftLead || 0,
        lead: result.myLead || 0,
        opportunity: result.myOpportunity || 0,
      }
    : {
        draftlead: result.totalDraftLead || 0,
        lead: result.totalLead || 0,
        opportunity: result.totalOpportunity || 0,
      }

export const closeMapBubbles = (hereMap: H.Map) => {
  const mapRoot = hereMap.getElement?.()
  if (!mapRoot) return

  const ui =
    (hereMap as any).__HMapUI ||
    (mapRoot as any).__HMapUI ||
    (mapRoot as any).ui

  if (ui && typeof ui.getBubbles === 'function') {
    ui.getBubbles().forEach((bubble: any) => {
      try {
        if (
          bubble.getState &&
          bubble.getState() !== H.ui.InfoBubble.State.CLOSED
        ) {
          bubble.close()
        }
        ui.removeBubble(bubble)
      } catch (err) {
        logger.warn('Error closing bubble:', err)
      }
    })
  }

  mapRoot.querySelectorAll('.H_ib, .H_ib_body').forEach((el) => el.remove())
}
